import { render } from "./AppointmentRequestView.vue?vue&type=template&id=899e395e&scoped=true"
import script from "./AppointmentRequestView.vue?vue&type=script&lang=js"
export * from "./AppointmentRequestView.vue?vue&type=script&lang=js"

import "./AppointmentRequestView.vue?vue&type=style&index=0&id=899e395e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899e395e"]])

export default __exports__